import * as React from 'react';

const SvgCloseSquare = (props) => (
  <svg
    width={20}
    height={21}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.725 5.095a.625.625 0 0 1 .884-.884l5.392 5.392 5.391-5.392a.625.625 0 0 1 .884.884l-5.392 5.391 5.392 5.392a.625.625 0 1 1-.884.884l-5.391-5.392-5.392 5.392a.625.625 0 1 1-.884-.884l5.392-5.392-5.392-5.391Z'
      fill='#ACA6A6'
    />
  </svg>
);

export default SvgCloseSquare;
